import { create_s3_upload_url_simple, gets3object, createS3UploadPresignedURL } from '../apis/s3access'
import axios from 'axios'


export const upload_single_object_to_s3 = async (bucket_name, obj, object_name, token, content_type = null) => {
    try {
        console.log("upload_single_object_to_s3: object_name: ", object_name, " file data: ", obj, " file type: ", obj.type)
        const res = await create_s3_upload_url_simple(token, bucket_name, object_name, obj, obj?.type ?? null)
        if (res?.obj?.error_code === 0) {
            const formData = new FormData()
            Object.entries(res.obj.msg.fields).forEach(([key, values]) => {
                formData.append(key, values);
            })
            if (obj?.type) {
                formData.append('Content-Type', obj.type)
            }
            formData.append('file', obj)
            try {
                const response = await axios.post(res.obj.msg.url, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                })
                console.log("upload_single_object_to_s3: response: ", response)
                return response
            } catch (err) {
                console.log("upload_single_object_to_s3: post request error", err)
                return null
            }
        } else {
            console.log("upload_single_object_to_s3", res)
            return null
        }
    } catch (err) {
        console.log("upload_single_object_to_s3: error: ", err)
        return null
    }
}





export const get_interviewerImage = async (object_name, token, bucket_name) => {
    const res = await gets3object(object_name, token, bucket_name)
    return res
}


export const fetchUploadPresignedUrl = async (token, bucket_name, object_name) => {
    try {
        const getUrlPayload = {
            token: token,
            bucket_name: bucket_name,
            object_name: object_name,
        }
        const presignedResponse = await createS3UploadPresignedURL(getUrlPayload)
        console.log("fetchUploadPresignedUrl: presignedResponse: ", presignedResponse)

        if (
          presignedResponse?.status !== 200
          || presignedResponse?.obj?.error_code !== 0
          || !presignedResponse?.obj?.presigned_url
        ) {
            throw new Error("fetchUploadPresignedUrl: Error in getting presigned url: " + presignedResponse?.obj)
        }

        const put_url = presignedResponse?.obj?.presigned_url?.url || null
        const headers = presignedResponse?.obj?.presigned_url?.headers || {}
        if(
          !put_url
          || typeof put_url !== "string"
          || !headers
        ){
            throw new Error("fetchUploadPresignedUrl: Presigned URL not found in response: " + JSON.stringify(presignedResponse))
        }

        return { put_url, headers };

    }catch(err){
        console.error(err);
        throw err;
    }
}



export function ensureFileType(file, category, preferredExt) {
  if (!(file instanceof File || file instanceof Blob)) {
    throw new Error('Input must be a File or Blob');
  }
  if (!['image', 'video', 'pdf'].includes(category)) {
    throw new Error(`Unsupported category: ${category}`);
  }

  const ACCEPT = {
    image: {
      mimes: new Set(['image/jpeg', 'image/png']),
      exts: new Set(['.jpg', '.jpeg', '.png']),
      extToMime: { '.jpg': 'image/jpeg', '.jpeg': 'image/jpeg', '.png': 'image/png' },
    },
    video: {
      mimes: new Set(['video/mp4', 'video/quicktime', 'video/x-msvideo']),
      exts: new Set(['.mp4', '.mov', '.avi']),
      extToMime: { '.mp4': 'video/mp4', '.mov': 'video/quicktime', '.avi': 'video/x-msvideo' },
    },
    pdf: {
      mimes: new Set(['application/pdf']),
      exts: new Set(['.pdf']),
      extToMime: { '.pdf': 'application/pdf' },
    },
  };

  const normalizeExt = (ext) =>
    !ext ? '' : ext.startsWith('.') ? ext.toLowerCase() : `.${ext.toLowerCase()}`;

  const getExtFromName = (name) => {
    const i = typeof name === 'string' ? name.lastIndexOf('.') : -1;
    return i >= 0 ? name.slice(i).toLowerCase() : '';
  };

  const spec = ACCEPT[category];

  // Determine extension (prefer the file name’s extension)
  let ext = normalizeExt(getExtFromName(file.name) || preferredExt);
  if (!ext || !spec.exts.has(ext)) {
    throw new Error(`Unsupported ${category} extension: ${ext || '(none)'}`);
  }

  // Determine MIME (prefer file.type, adjust legacy values, else infer from ext)
  let mime = (file.type || '').toLowerCase();
  if (mime === 'image/pjpeg') mime = 'image/jpeg'; // legacy IE value
  if (!mime) mime = spec.extToMime[ext];

  if (!mime || !spec.mimes.has(mime)) {
    throw new Error(`Unsupported ${category} MIME type: ${mime || '(none)'}`);
  }

  return { mime, ext };
}